// This displays if the field is mapped from a ContactSubType
<template>
  <div v-if='typeof(field.from_cst)==="object"' class="tw-banner-info w-full">
    <i class="tw-icon information-circle-white"/>
    Mapped from {{ field.from_cst.label }} data
  </div>
</template>
<script setup>
const props = defineProps(['field'])
</script>